import React from 'react';
import { IconType } from 'react-icons';
import './EmptyState.css';

interface EmptyStateProps {
  icon?: IconType;
  title: string;
  subtitle?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, subtitle }) => {
  return (
    <div className="empty-state-container">
      {Icon && (
        <div className="empty-state-icon">
          {React.createElement(Icon as React.ElementType)}
        </div>
      )}
      <p className="empty-state-title">{title}</p>
      {subtitle && <p className="empty-state-subtitle">{subtitle}</p>}
    </div>
  );
};

export default EmptyState;
